
import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { configs } from '../constants/configs/configs';


export const useTitle = (initialValue = '', data) => {

    const [ title, toggleTitle ] = useState(initialValue);

    const {
        adjustedFlow,
        exchangeName,
        page,
        pathname,
        language,
        loadedLanguages = []
    } = data;

    const intlApi = useIntl();
    let newTitle;

    const intlSsapPageName = () => { 
        return adjustedFlow[page] ? `${intlApi.formatMessage({ id: adjustedFlow[page].page.navBarText })} - ` + `${intlApi.formatMessage({ id: 'pageTitle.ssap_application' })} - ${exchangeName}` : exchangeName;
    };

    useEffect(() => {

        switch(pathname) {
            case configs.routes.HOME:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.home' }, { exchangeName })}`;
                break;
            case configs.routes.ACCESS_CODE:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.accessCode' }, { exchangeName })}`;
                break;
            case configs.routes.PRE_ELIGIBILITY_SCREENING:
            case configs.routes.PRE_ELIGIBILITY_SCREENING_FROM_HOME:
            case configs.routes.PRE_ELIGIBILITY_SCREENING_FROM_FLOW:
                newTitle = `${intlApi.formatMessage({ id: 'anonymous.pre_eligibility.pre_screen.pageTitle' }, { exchangeName })}`;
                break;
            case configs.routes.PRE_ELIGIBILITY_RESULTS:
                newTitle = `${intlApi.formatMessage({ id: 'anonymous.pre_eligibility.results.pageTitle' }, { exchangeName })}`;
                break;
            case configs.routes.INDPORTAL:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.dashboard' }, { exchangeName })}`;
                break;
            case configs.routes.APPLICATIONS:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.applications' }, { exchangeName })}`;
                break;
            case configs.routes.ELIGIBILITY_RESULTS:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.eligibilityresults' }, { exchangeName })}`;
                break;
            case configs.routes.COMMUNICATION_PREFERENCES:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.preferences' }, { exchangeName })}`;
                break;
            case configs.routes.NEW_INBOX_HOME:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.myinbox' }, { exchangeName })}`;
                break;
            case configs.routes.COMMUNICATION_PREFERENCES_AC:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.preferences_ac' }, { exchangeName })}`;
                break;
            case configs.routes.TICKET_CONSUMER:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.tickets' }, { exchangeName })}`;
                break;
            case configs.routes.TICKET_CONSUMER_DETAIL:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.tickets_details' }, { exchangeName })}`;
                break;
            case configs.routes.VERIFICATION_DOCUMENTS:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.qle' }, { exchangeName })}`;
                break;
            case configs.routes.FORGOT_EMAIL:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.forgot_email' }, { exchangeName })}`;
                break;
            case configs.routes.DELEGATION_CONSUMER:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.delegates' }, { exchangeName })}`;
                break;
            case configs.routes.SSAP:
                newTitle = intlSsapPageName();
                break;
            default:
                newTitle = exchangeName;
        }

        toggleTitle(newTitle);

    }, [ page, adjustedFlow.length, language, pathname, loadedLanguages.length ]);

    useEffect(() => {
        document.title = title;
    }, [ title ]);
};